// @ts-nocheck
import { jotaiStore } from 'init';
import { i18nKeys } from 'locales';
import { ublProgressAtom } from 'modules/Import/ublProgressAtom';
import { delay } from 'redux-saga';
import { all, call, takeLatest } from 'redux-saga/effects';
import { error, success } from 'shared/notifications';
import { downloadFile, extractFilename } from 'shared/utils/view';
import { accountActions, accountConstants as events } from 'store/account/account.actions';
import { api } from 'store/apis';

import { apiCall, sendApi } from '../sagas';

/**
 * Download terms
 */
function* downloadTerms({ payload }: any) {
  const request = yield call(apiCall, {
    api: api.company.getTerms,
    id: payload.id,
    data: payload,
  });

  if (request && request.status === 200) {
    const filename = extractFilename(request.headers);
    downloadFile(request.data, filename || 'recovr.company-terms.pdf');
  } else {
    yield error({
      text: i18nKeys.ERROR.DOC_NOT_AVAILABLE,
    });
  }
}

/**
 * Import
 */
function* importInvoice({ payload }: any) {
  const { ublFiles, planId } = payload;

  jotaiStore.set(ublProgressAtom, { active: true, value: 0 });

  const errors: string[] = [];

  for (let i = 0; i < ublFiles.length; i++) {
    yield call(apiCall, {
      api: api.invoice.import.ubl,
      fileUpload: true,
      noFeedback: true,
      noLoading: true,
      progress: () => {},
      data: {
        invoice_ubl_file: ublFiles[i],
        recovery_plan_id: planId,
      },
      actionFailure: response => {
        errors.push(response?.data?.error_message ?? '');
        jotaiStore.set(ublProgressAtom, { active: true, value: (100 * (i + 1)) / ublFiles.length });
      },
      callback: () =>
        jotaiStore.set(ublProgressAtom, {
          active: true,
          value: Math.round((100 * (i + 1)) / ublFiles.length),
        }),
    });
  }

  if (errors.length > 0) jotaiStore.set(ublProgressAtom, { active: true, errors });
  else {
    yield success({ text: i18nKeys.INVOICE.SUCCESSFUL_IMPORT });
    yield call(delay, 500);
    if (payload.callback) yield call(payload.callback);
  }
}

function* UserWatchers() {
  yield all([
    yield takeLatest(events.syncIntegration.request, sendApi(api.settings.syncIntegration)),
    yield takeLatest(events.syncIntegrationPdfs.request, sendApi(api.settings.syncIntegrationPdfs)),
    yield takeLatest(events.importInvoice.request, importInvoice),
    yield takeLatest(events.updateYukiSettings.request, sendApi(api.settings.updateYukiSettings)),
    yield takeLatest(events.updateHorusSettings.request, sendApi(api.settings.updateHorusSettings)),
    yield takeLatest(
      events.updateDbasicsSettings.request,
      sendApi(api.settings.updateDbasicsSettings),
    ),
    yield takeLatest(
      events.setDigitealConfiguration.request,
      sendApi(api.settings.setDigitealConfiguration),
    ),
    yield takeLatest(
      events.updateTeamleaderSettings.request,
      sendApi(api.settings.updateTeamleaderSettings),
    ),
    yield takeLatest(events.updateExactSettings.request, sendApi(api.settings.updateExactSettings)),
    yield takeLatest(events.horusFetchCompanies.request, sendApi(api.settings.horusFetchCompanies)),
    yield takeLatest(events.exactFetchCompanies.request, sendApi(api.settings.exactFetchCompanies)),
    yield takeLatest(
      events.activityPage.request,
      sendApi(api.activity.list, accountActions.activityPageRes, payload => ({
        data: payload,
        noLoading: true,
      })),
    ),
    yield takeLatest(events.activityDetail.request, sendApi(api.activity.detail)),
    yield takeLatest(
      events.activitySeen.request,
      sendApi(api.activity.markAsRead, accountActions.activitySeenRes),
    ),
    yield takeLatest(events.activitySeenAll.request, sendApi(api.activity.markAllAsRead)),
    yield takeLatest(events.getDigitealCGV.request, sendApi(api.settings.getDigitealCGV)),
    yield takeLatest(events.getTerms.request, downloadTerms),
  ]);
}

export default function* saga() {
  yield call(UserWatchers);
}
